import { useState } from "react";
import { NormasTeachingProductCheckoutForm } from "./NormasTeachingProductCheckoutForm.tsx";
import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { useNormasTeachingProductById } from "../../ProductService/NormasTeachingProduct/useNormasTeachingProductById.ts";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { MainContainer } from "../../UI/Layout/MainContainer.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { ErrorPopup } from "../../UI/Error/ErrorPopup.tsx";
import { usePopupController } from "../../HeyLight/usePopupController.ts";
import { useAnalyticsParams } from "../../MoneyTransfer/useAnalyticsParams.ts";
import { PaymentMethodRouter } from "../PaymentSteps/PaymentMethodRouter.tsx";
import { NormasTeachingCheckoutItem } from "../PaymentSteps/PaymentMethodStepInterface.ts";
import { ItemType, NormasTeachingCheckoutFormData } from "../CheckoutData.ts";

export function NormasTeachingProductCheckoutScreenInner({
  productId,
}: {
  productId: string;
}) {
  const { product, isLoading } = useNormasTeachingProductById(productId);
  const { openPopup, closePopup, open, title, description } =
    usePopupController();
  const { analyticsParams } = useAnalyticsParams();

  const [checkoutData, setCheckoutData] =
    useState<NormasTeachingCheckoutFormData | null>(null);

  const onFormSubmit = (data: NormasTeachingCheckoutFormData) => {
    setCheckoutData(data);
    setTimeout(() => window.scrollTo(0, 0), 0);
  };

  const onPaymentSuccess = () => {
    setTimeout(() => {
      const succeededUrl = product?.stripeConfig?.succeededUrl;
      if (succeededUrl) {
        window.location.href = succeededUrl;
      } else {
        setCheckoutData(null);
      }
    }, 0);
  };

  const onPaymentError = (errorMessage: string) => {
    openPopup({
      title: "Errore nel pagamento",
      description: errorMessage,
      timeoutMs: 5000,
    });
  };

  const onBackToForm = () => {
    setCheckoutData(null);
  };

  if (isLoading) return <FullPageLoading />;
  // A disabled product is off sale, so the checkout treats it exactly like one
  // that does not exist. `isEnabled` is absent on products created before the
  // flag existed, hence the explicit comparison.
  if (!product || product.isEnabled === false) return <p>Product not found</p>;

  const item: NormasTeachingCheckoutItem = {
    _id: product._id,
    priceInCents: product.priceInCents,
    itemName: product.productName,
  };
  return (
    <Layout>
      <NavBar />
      <MainContainer key={checkoutData ? "payment" : "form"}>
        <ErrorPopup
          open={open}
          onClose={closePopup}
          title={title}
          description={description}
        />

        {/* Step 1: Form dati utente + selezione metodo */}
        {!checkoutData && (
          <NormasTeachingProductCheckoutForm
            submitting={false}
            onFormSubmit={onFormSubmit}
            product={product}
          />
        )}

        {/* Step 2: Payment Router */}
        {checkoutData && (
          <PaymentMethodRouter
            checkoutData={checkoutData}
            normasTeachingItem={item}
            itemType={ItemType.Product}
            analyticsParams={analyticsParams}
            onSuccess={onPaymentSuccess}
            onError={onPaymentError}
            onBack={onBackToForm}
          />
        )}
      </MainContainer>
      <Footer />
    </Layout>
  );
}
